import React, { useEffect, useRef } from 'react';

import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';

import { useNavigate } from '@utils/hooks';

import { cardsActions, operationBlockActions, useStore } from '@modules';

import BindVerifyCardStatus from '@containers/BindVerifyCardStatus';
import useData from '@containers/OperationBlock/useData';
import VerifyCard from '@containers/VerifyCard';
import MainLayout from '@layouts/MainLayout';
import AddCard from '@pages/AddCard';
import { getOperations } from '@selectors';

const OperationWithNewCard: CustomFC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [store, dispatch] = useStore();
  const operations = getOperations(store);
  const leftData = useData();
  const cardId = useRef<string>(undefined);

  useEffect(() => {
    if (cardId.current) {
      const card = leftData
        .find(group => group.key === 'cards')
        ?.list.find(c => c.value === cardId.current);
      if (card) {
        if (operations.buy_with_new_card) dispatch(operationBlockActions.setLeft(card));
        if (operations.sell_with_new_card) dispatch(operationBlockActions.setRight(card));
      }
      navigate<'wallets'>(CONST.nav.wallets, { state: { cacheConverter: true } });
    }
  }, [leftData]);

  const onSuccess = (bindStatus?: string) => {
    if (bindStatus === CONST.card3DS.statuses.succeeded) {
      dispatch(cardsActions.getCards())
        .unwrap()
        .then(res => {
          cardId.current = res.data.at(-1)?.id;
        });
    } else if (bindStatus === CONST.card3DS.statuses.failed) {
      navigate<'addCard'>(CONST.nav.operationWithNewCard, {
        state: { showFailedNotification: true },
      });
    }
  };

  const getTitle = () => {
    switch (true) {
      case operations.buy_with_new_card:
        return t('card.buy_with_new_card_title');
      case operations.sell_with_new_card:
        return t('card.sell_with_new_card_title');
      default:
        return t('card.add_new_card');
    }
  };

  return (
    <BindVerifyCardStatus onSuccess={onSuccess}>
      <Routes>
        <Route
          path="*"
          element={
            <AddCard
              title={getTitle()}
              backRoute={CONST.nav.wallets}
              verificationRoute={CONST.nav.operationWithNewCardVerify}
            />
          }
        />
        <Route
          path="verify"
          element={
            <MainLayout backButton={() => navigate(CONST.nav.operationWithNewCard)}>
              <VerifyCard onSuccessFlow={onSuccess} />
            </MainLayout>
          }
        />
      </Routes>
    </BindVerifyCardStatus>
  );
};

export default OperationWithNewCard;
